
import React, { useState, useEffect, useCallback } from 'react';
import { Navigate, useParams } from "react-router-dom";

import { Button, FormControl, InputLabel, OutlinedInput } from "@mui/material";
import Grid from '@mui/material/Grid2';
import { 
  User, 
} from "@models";

import DandDAPI from "@dndUtilities/system_api";

import LoadingBox from "@components/input/LoadingBox";
import StringBox from "@components/input/strings/StringBox";
import CheckBox from "@components/input/CheckBox";
import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";

const api = DandDAPI.getInstance();
// const common_util = DataUtilities.getInstance();

export default function UserEdit() {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [navigateTo, setNavigateTo] = useState<string | null>(null);
  const [obj, setObj] = useState<User>(new User());
  const [password, setPassword] = useState("");
  const [confirm_password, setConfirmPassword] = useState("");
  const [change_password, setChangePassword] = useState(false);
  const [ping, setPing] = useState(false);
  
  const disabled = api.user === null || !api.online || (!api.user.is_admin && obj._id !== "" && obj._id !== api.user._id);

  // This is a better way for loading, without using the 'fetched' method.
  useEffect(() => {
    const load = async () => {
      if (id && id !== "") {
        setLoading(true);
        const res = await api.getPlayerObject<User>({ data_type: "user", id });
        if (res) {
          setObj(res);
          setPing(prev => !prev);
        }
        setLoading(false);
      }
    };
    
    load();
  }, [id]); // Only re-run when id changes

  const submit = async () => {
    if (api.user && 
      (api.user.is_admin || 
        obj._id === "" || 
        obj._id === api.user._id)) {
      setProcessing(true);
      const new_obj = obj.clone();
      if (change_password) {
        new_obj.password = password;
      }
      await api.upsertObject("user", new_obj);
      if (api.user._id === new_obj._id) {
        api.user = new_obj;
        api.subscription_holder.reload();
      }
      setProcessing(false);
      setNavigateTo("/labs/user");
    }
  }

  const reload = async () => {
    // debugger;
    if (api.user) {
      setProcessing(true);
      const res = await api.getPlayerObject<User>({ data_type: "user", id: api.user._id });
      if (res) {
        setObj(res);
        api.user = res;
        api.subscription_holder.reload();
        setLoading(false);
      }
      setProcessing(false);
    }
  }

  const height = window.innerHeight - 105;
  if (loading) {
    return (<LoadingBox size={height * 0.5} height={height} width={window.innerWidth} />);
  } else if (navigateTo !== null) {
    return <Navigate to={navigateTo} />;
  } else { 
    // const formHeight = window.innerHeight - (window.innerWidth > 600 ? 220 : 220);
    return (
      <div style={{ height }}>
        <Grid container spacing={0} direction="row">
          <Grid
            size={{
              xs: 12
            }}>
            <StringBox 
              name="Username"
              value={obj.username} 
              message={obj.username.length > 0 ? "" : "Name Invalid"}
              onBlur={(changed: string) => {
                const new_obj = obj.clone();
                new_obj.username = changed;
                setObj(new_obj);
                setPing(!ping);
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <StringBox 
              name="Email"
              value={obj.email} 
              onBlur={(changed: string) => {
                const new_obj = obj.clone();
                new_obj.email = changed;
                setObj(new_obj);  
                setPing(!ping);
              }}
            />
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <ToggleButtonBox
              name='Change Password'
              value={change_password}
              onToggle={() => { setChangePassword(!change_password); }}
            />
          </Grid>
          { change_password &&
            <>
              <Grid
                size={{
                  xs: 12
                }}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel htmlFor="text_field_login_password">Password</InputLabel>
                    <OutlinedInput
                      id={`text_field_login_password`}
                      name={`text_field_login_password`}
                      // type="password"
                      autoComplete="Off"
                      // error={error !== ""}
                      value={password}
                      onChange={e => {
                        setPassword(e.target.value);
                        setPing(!ping);
                      }}
                      // labelWidth={70}
                      fullWidth
                    />
                </FormControl>
              </Grid>
              <Grid
                size={{
                  xs: 12
                }}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel htmlFor="text_field_login_confirm_password">Confirm Password</InputLabel>
                    <OutlinedInput
                      id={`text_field_login_confirm_password`}
                      name={`text_field_login_confirm_password`}
                      // type="password"
                      autoComplete="Off"
                      // error={error !== ""}
                      value={confirm_password}
                      onChange={e => {
                        setConfirmPassword(e.target.value);
                        setPing(!ping);
                      }}
                      // labelWidth={140}
                      fullWidth
                    />
                </FormControl>
              </Grid>
            </>
          }
          { api.user && api.user.is_admin &&
            <Grid
              size={{
                xs: 12
              }}>
              <CheckBox 
                name="View Blocked Source Books"
                value={obj.view_blocked_source_books} 
                onChange={(value: boolean) => {
                  const new_obj = obj.clone();
                  new_obj.view_blocked_source_books = value;
                  setObj(new_obj);
                  setPing(!ping);
                }} 
              />
            </Grid>
          }
          { api.user && api.user.is_admin &&
            <Grid
              size={{
                xs: 12
              }}>
              <b>Current Password:</b> { obj.password }
            </Grid>
          }
          { !disabled &&
            <Grid
              size={{
                xs: 12
              }}>
              <Button
                variant="contained"
                color="primary"
                disabled={processing || (change_password && (password === "" || password !== confirm_password))}
                onClick={submit}>
                Submit
              </Button>
              <Button
                variant="contained"
                disabled={processing}
                style={{ marginLeft: "4px" }}
                onClick={ () => { 
                  setNavigateTo(`/dandd/user`);
                }}>
                Cancel
              </Button>
              { api.user && api.user._id === obj._id &&
                <Button
                  variant="contained"
                  color="primary"
                  disabled={processing}
                  style={{ marginLeft: "4px" }}
                  onClick={reload}>
                  Reload Your User
                </Button>
              }
            </Grid>
          }
        </Grid>
      </div>
    ); 
  }
}
